import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import PrivateRoute from './routes/PrivateRoute';
import HomeScreen from './screens/HomeScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ProfileScreen from './screens/ProfileScreen';
import DashboardScreen from './screens/DashboardScreen';
import QuizScreen from './screens/QuizScreen';
import ResultsScreen from './screens/ResultsScreen';
import AdminRoute from './routes/AdminRoute';
import AdminAnswersScreen from './screens/admin/AdminAnswersScreen';
import AdminResultsScreen from './screens/admin/AdminResultsScreen';
import AdminUsersScreen from './screens/admin/AdminUsersScreen';

const App = () => {
  return (
    <Router>
      <Header />
      <main className='pt-3'>
        <Route exact path='/' component={HomeScreen} />
        <Route path='/login' component={LoginScreen} />
        <Route path='/register' component={RegisterScreen} />

        <PrivateRoute path='/profile' component={ProfileScreen} />
        <PrivateRoute path='/dashboard' component={DashboardScreen} />
        <PrivateRoute path='/quiz' component={QuizScreen} />
        <PrivateRoute path='/results' component={ResultsScreen} />

        <AdminRoute
          exact
          path='/admin/answers'
          component={AdminAnswersScreen}
        />
        <AdminRoute path='/admin/answers/:id' component={AdminResultsScreen} />
        <AdminRoute path='/admin/users' component={AdminUsersScreen} />
      </main>
      <Footer />
    </Router>
  );
};

export default App;
